module.exports = __webpack_public_path__ + "assets/img/99@3x.245026c4.png";